//EXTERNAL
import { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
//TYPES
import { PaginationProps } from "../types";

// Utility functions controlling table component pagination
export function usePagination({ limit, setOffset }: PaginationProps) {
  const { search } = useLocation();
  let params = new URLSearchParams(search);
  const history = useHistory();

  const handlePageNumber = (pageNumber: number) => {
    params.set("page", `${pageNumber + 1}`);
    history.push({ search: `?${params.toString()}` });
  };

  const handleSequentialPageNumber = (offset: number, direction: string) => {
    let pageNumber = Math.ceil(offset / limit);
    if (direction === "next") {
      pageNumber = pageNumber + 1;
    } else {
      pageNumber = pageNumber - 1;
    }
    params.set("page", `${pageNumber + 1}`);
    history.push({ search: `?${params.toString()}` });
  };

  const handleOffsetHandler = (pageIndex: number) => {
    setOffset(pageIndex * limit);
  };

  const handleSequentialPage = (offset: number, direction: string) => {
    if (direction === "next") {
      setOffset(offset + limit);
    } else {
      setOffset(offset - limit);
    }
  };
  return { handleOffsetHandler, handleSequentialPage, handlePageNumber, handleSequentialPageNumber };
}
